import { createContext } from "react";

/** Lets a page choose whether the layout wraps it in the content card. */
export type PageFrameContextValue = {
    /**
     * Requests the content card (true, the default) or none, for pages that lay out their own
     * cards on the page background.
     */
    setFramed: (framed: boolean) => void;
};

/**
 * Provides the layout's content card switch.
 *
 * Postconditions: Without a provider, such as in the legacy layout, the switch does nothing.
 */
const PageFrameContext = createContext<PageFrameContextValue>({ setFramed: () => undefined });

export default PageFrameContext;
